import {useEffect} from 'react'
import {Navigate, useLocation, Outlet} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {LoadingComponent, InfoMessage, ContentContainer} from '@components/lib'

import {useProfile} from 'hooks'
import routes from 'routes/pathConfig'
import {MainLayout} from 'layouts'
import {isProfileConfirmed, getDevice} from 'utils'
import useAuthToken from 'hooks/persisted/useAuthToken'
import useOnUnauthorized from 'hooks/api/useOnUnauthorized'
import ModalTermsCondition from 'components/modals/ModalTermsCondition'
import ModalTutorial from 'components/modals/ModalTutorial'

const AuthRoute = ({roles}) => {
  const {t} = useTranslation()
  const location = useLocation()
  const {profile, isLoadingProfile} = useProfile()
  const {role, isExpired, authToken} = useAuthToken()

  const onUnauthorized = useOnUnauthorized()

  useEffect(() => {
    if (isExpired) {
      onUnauthorized('Session expired')
      return () => {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpired])

  /**
   * If device is moblie and installed app then redirect to app,
   * otherwise stay web for referred for registation
   */
  if (location.search.includes('?su=')) {
    if (['Android', 'iOS'].includes(getDevice())) {
      window.location.replace(`minebase:///signUpPage/${location?.search?.split('su=')[1]}`)
      setTimeout(() => <Navigate to={routes.register.path} state={{from: location}} />, 1000)
    }
    return <Navigate to={routes.register.path} state={{from: location}} />
  }

  if (!authToken) {
    return <Navigate to={routes.login.path} state={{from: location}} replace />
  }

  if (isLoadingProfile) {
    return (
      <ContentContainer withNavPadding>
        <LoadingComponent />
      </ContentContainer>
    )
  }

  if (!profile) {
    return (
      <Navigate
        to={routes.login.path}
        state={{from: location, message: t('login.errors.pageAccessDenied')}}
      />
    )
  }
  if (!isProfileConfirmed(profile)) {
    return <Navigate to={routes.register.path} state={{from: location}} />
  }

  if (roles && !roles.includes(role)) {
    return (
      <ContentContainer withNavPadding>
        <InfoMessage
          nature='warning'
          text={t('login.errors.roleNotAllowed')}
          style={{marginTop: 15}}
        />
      </ContentContainer>
    )
  }

  return (
    <MainLayout>
      <ModalTermsCondition />
      {/* <ModalPartnerInfo /> */}
      <ModalTutorial />
      <Outlet />
    </MainLayout>
  )
}

export default AuthRoute
